import { render, staticRenderFns } from "./report-baolist.vue?vue&type=template&id=b2321958&scoped=true&"
import script from "./report-baolist.vue?vue&type=script&lang=js&"
export * from "./report-baolist.vue?vue&type=script&lang=js&"
import style0 from "./report-baolist.vue?vue&type=style&index=0&id=b2321958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2321958",
  null
  
)

export default component.exports